import axios from 'axios'

axios.defaults.headers = {
  'Content-Type': 'application/json'
}

export default {
  fetchNewsCollection (newsFeed) {
    return axios.get('https://api.rss2json.com/v1/api.json', {
      params: {
        rss_url: newsFeed,
        api_key: 'wd8jfv3modteiczerjxtbhhifsslr2zt5o4pg5br',
        format: 'json'
      }
    })
      .then(response => {
        return response.data
      })
  }
}
